@if (pdfUrl) {
  <div class="pdf-container">
    <iframe
      [src]="pdfUrl"
      width="100%"
      height="100%"
      title="PDF Viewer">
    </iframe>
  </div>
}

